export const UNINITIALIZED = 'UNINITIALIZED';
export const PENDING = 'PENDING';
export const SUCCEEDED = 'SUCCEEDED';
export const FAILED = 'FAILED';
export const PRECONDITION_FAILED = 'PRECONDITION_FAILED';
export const NOT_FOUND = 'NOT_FOUND';